import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/core/base.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { GtStripeService } from 'src/app/shared/services/gt-stripe.service';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
    selector: 'stripe-terminal-locations',
    templateUrl: './stripe-terminal-locations.component.html',
    styleUrl: './stripe-terminal-locations.component.scss',
    standalone: false
})
export class StripeTerminalLocationsComponent extends BaseComponent{
  @Input() public locations: any[] = [];
  @Input() public readers: any[] = [];
  @Output() createReaderEvent = new EventEmitter();
  @Output() deleteReaderEvent = new EventEmitter();

  public panelOpenState = false;
  public isRefreshing = false;

  constructor(private stripeService: GtStripeService,
    private dialog: MatDialog,
    sessionService: SessionService,
    stringHelpers: StringHelpers){
      super(sessionService, stringHelpers);
  }


  createReader(location){
    this.createReaderEvent.emit(location.id);
  }

  deleteReader(reader){
    const dialogRef = this.dialog.open(AlertModalComponent);

    dialogRef.componentInstance.body = `Are you sure you want to delete Reader ${reader.label}?`;
    dialogRef.componentInstance.title = 'Delete Reader';
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;

    dialogRef.afterClosed().subscribe(result => {
      if(result === 'Yes'){
        this.stripeService.deleteTerminalReader({accountId: this.sessionService.getUser().stripeAccountId, readerId: reader.id}).subscribe({
          next: () => {
            this.deleteReaderEvent.emit();
          },
          error: (err) => {
            console.log(err);
          }
        });
      }
    });

    this.isLoading = true;
  }

  deleteLocation(location){
    const dialogRef = this.dialog.open(AlertModalComponent);

    dialogRef.componentInstance.body = `Are you sure you want to delete Reader ${location.displayName}?`;
    dialogRef.componentInstance.title = 'Delete Location';
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;

    dialogRef.afterClosed().subscribe(result => {
      if(result === 'Yes'){
        this.stripeService.deleteTerminalLocation({accountId: this.sessionService.getUser().stripeAccountId, locationId: location.id}).subscribe({
          next: () => {
            this.deleteReaderEvent.emit();
          },
          error: (err) => {
            console.log(err);
          }
        });
      }
    });

    this.isLoading = true;
  }

  refreshReader(reader){
    reader.isRefreshing = true;

    let index = this.readers.find(x => x.id === reader.id);
    
    this.stripeService.getTerminalReaderById(reader.id, this.sessionService.getUser().stripeAccountId).subscribe({
      next: result => {
        if(result.status !== reader.status){
          this.readers[index] = result;
        }
      },
      error: err => console.log(err),
      complete: () =>  reader.isRefreshing = false

    });
  }
}
